import { render, staticRenderFns } from "./ptTableRowLottery.vue?vue&type=template&id=550ec19b&lang=pug&"
import script from "./ptTableRowLottery.vue?vue&type=script&lang=js&"
export * from "./ptTableRowLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports